// SECTION navgation
(function(){
  // ANCHOR fixedOpen
  const fixedOpen = (_cls)=>{
    document.body.setAttribute('style',`top:-${window.pageYOffset}px`);
    document.body.classList.add(_cls);
  };

  // ANCHOR fixedClose
  const fixedClose = (_cls)=>{
    const getY = ( callback )=>{
      const settop = document.body.style.top;
      const y = settop.slice(1,-2);
      document.body.style.top = '';
      document.body.classList.remove(_cls);
      callback(y);
    };
    getY((y)=>{
      window.scrollTo({
        top: y,
        left: 0,
        behavior: "instant",
      });
    });
  };

  const openbutton = document.querySelector('.js-menuopen');
  const closebuttons = document.querySelectorAll('.js-menuclose');
  const links = document.querySelectorAll('.sw-nav-shoplist .sw-nav-menu__link.close');
  if( links.length ){
    links.forEach( link => {
      link.addEventListener('click',(e)=>{
        e.preventDefault();
        const _this = e.currentTarget;
        const href = _this.getAttribute('href');
        fixedClose('is-nav-open');
        setTimeout(()=>{
          location.href = href;
        },100);
      });
    });
  }
  openbutton.addEventListener('click',(e)=>{
    fixedOpen('is-nav-open');
  });

  closebuttons.forEach( closebutton =>{
    closebutton.addEventListener('click',(e)=>{
      fixedClose('is-nav-open');
    });
  });

})();
// !SECTION

// SECTION common
(function(){

  const homeHeader = () =>{
    if( document.querySelector('.sw-main.-home') ){
      document.querySelector('.container').classList.add('-home');
      document.querySelector('.sw-header').classList.add('-home');
      window.addEventListener('scroll',()=>{
        const header = document.querySelector(".sw-header");
        if( window.pageYOffset > header.clientHeight ){
          header.classList.add('is-fixed');
        }else{
          header.classList.remove('is-fixed');
        }
      });
    }
  }

  const jsMh = ()=>{
    if( document.querySelectorAll('.js-mh').length ){
      jQuery('.js-mh').matchHeight();
    }
  }

  const jsAcod = ()=>{
    if( document.querySelectorAll('.js-acod').length ){
      const acods = document.querySelectorAll('.js-acod');
      acods.forEach( acod => {
        if( !acod.classList.contains('is-open') ){
          const content = document.getElementById( acod.getAttribute( 'aria-controls' ) );
          content.style.display = 'none';
        }
        acod.addEventListener('click',( e )=>{
          const _this = e.currentTarget;
          const content = document.getElementById( _this.getAttribute( 'aria-controls' ) );
          _this.classList.toggle('is-open');
          if( _this.classList.contains('is-open') ){
            jQuery( content ).stop(false,false).slideDown();
          }else{
            jQuery( content ).stop(false,false).slideUp();
          }
        });
      });
    }
  }

  const scrlAnime = ()=>{
    if( document.querySelectorAll('[class*="sw-js-"]').length ){
      let scrls = document.querySelectorAll('[class*="sw-js-"]');
      scrls.forEach( scrl => {
        const rect = scrl.getBoundingClientRect();
        if( rect.top < window.innerHeight*0.75 ){
          scrl.classList.add('is-inview');
        }
      });
      window.addEventListener('scroll' , ()=> {
        scrls.forEach( scrl => {
          const rect = scrl.getBoundingClientRect();
          if( rect.top < window.innerHeight*0.75 ){
            scrl.classList.add('is-inview');
          }
        });
      });
      window.addEventListener('shopify:section:load',()=>{
        scrls = document.querySelectorAll('[class*="sw-js-"]');
        scrls.forEach( scrl => {
          const rect = scrl.getBoundingClientRect();
          if( rect.top < window.innerHeight*0.75 ){
            scrl.classList.add('is-inview');
          }
        });
      });
      window.addEventListener('shopify:section:reorder',()=>{
        scrls = document.querySelectorAll('[class*="sw-js-"]');
        scrls.forEach( scrl => {
          const rect = scrl.getBoundingClientRect();
          if( rect.top < window.innerHeight*0.75 ){
            scrl.classList.add('is-inview');
          }
        });
      });
    }
  }

  const featBlk = ()=>{
    if( document.querySelectorAll('.sw-coll-featblk__header > i:not([class])').length ){
      const eles = document.querySelectorAll('.sw-coll-featblk__header > i:not([class])');
      for( let i = 0 ; i < eles.length ; i++ ){
        const el = eles[i];
        if( i === 0 ){
          el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="38.08" height="27" viewBox="0 0 38.08 27"><path d="M9.48.32c-2.8 0-5.16 1.6-6.84 4.72A23.4 23.4 0 000 15.68C0 22.52 2.68 27 6.84 27c2.64 0 5.32-1.88 6.92-4.96a26.15 26.15 0 002.92-11.32c0-6.56-2.64-10.4-7.2-10.4zM8.32 2.16c3.32 0 5.64 4.76 5.64 11.44a17.177 17.177 0 01-1.88 8.32c-1.04 1.76-2.28 2.64-3.84 2.64-3.4 0-5.92-4.6-5.92-10.72 0-6.4 2.72-11.68 6-11.68zm28.44 3.68a26.3 26.3 0 01.68-4.08 4.9 4.9 0 00.24-1.24c0-.36-.16-.52-.44-.52a1.53 1.53 0 00-.84.48 6.573 6.573 0 01-1.8 1.28l-1.52.68c-2.4 1.08-2.4 1.08-2.4 1.6a.454.454 0 00.44.48 1.816 1.816 0 00.72-.16 4.688 4.688 0 011.4-.36c.56 0 .84.32.84 1a11.7 11.7 0 01-.16 1.72l-1.8 15.04c-.4 3.2-.76 3.72-2.68 3.84-.68.04-1 .24-1 .68 0 .32.28.56.72.56.12 0 .12 0 .72-.04a26.235 26.235 0 013.44-.16 28.859 28.859 0 013.32.16 4.625 4.625 0 00.68.04c.48 0 .76-.2.76-.6 0-.48-.28-.64-1.2-.68-1.64-.08-2.2-.6-2.2-2.08 0-.48.04-.92.08-1.4z" fill="#bc818b"/></svg>';
        }else if( i === 1 ){
          el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="40.32" height="26.68" viewBox="0 0 40.32 26.68"><path d="M11.88-26.4c-2.8,0-5.16,1.6-6.84,4.72A23.4,23.4,0,0,0,2.4-11.04C2.4-4.2,5.08.28,9.24.28c2.64,0,5.32-1.88,6.92-4.96A26.15,26.15,0,0,0,19.08-16C19.08-22.56,16.44-26.4,11.88-26.4Zm-1.16,1.84c3.32,0,5.64,4.76,5.64,11.44A17.177,17.177,0,0,1,14.48-4.8c-1.04,1.76-2.28,2.64-3.84,2.64-3.4,0-5.92-4.6-5.92-10.72C4.72-19.28,7.44-24.56,10.72-24.56Zm25.8,14.6a50.046,50.046,0,0,0,3.88-5.96c1.44-2.6,1.92-4.08,1.92-5.8,0-2.72-2.28-4.68-5.4-4.68a7.991,7.991,0,0,0-4.72,1.6c-1.4,1.04-2.44,2.24-2.44,2.76a.552.552,0,0,0,.48.48,1.078,1.078,0,0,0,.6-.2,11.273,11.273,0,0,1,1.92-1.52,6.546,6.546,0,0,1,3.08-.8,2.922,2.922,0,0,1,3.12,3.2,16.218,16.218,0,0,1-2.12,7.04A72.07,72.07,0,0,1,31.6-5.88L28.04-1.56c-.68.84-.72.92-.72,1.2s.32.52.72.52a4.563,4.563,0,0,0,.84-.12,43.52,43.52,0,0,1,4.96-.2c1.36,0,3.72.12,4.32.2.4.04.76.08.96.08.32,0,.4-.04.76-.6l2.44-3.48a1.894,1.894,0,0,0,.4-.76c0-.24-.28-.44-.6-.44-.28,0-.52.16-.92.6-1.32,1.44-2.4,1.84-5.04,1.84-3.96,0-4.48-.08-4.48-.6,0-.2.12-.44.48-.92Z" transform="translate(-2.4 26.4)" fill="#bc818b"/></svg>';

        }else if( i === 2 ){
          el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="39.96" height="26.72" viewBox="0 0 39.96 26.72"><path d="M11.88-26.4c-2.8,0-5.16,1.6-6.84,4.72A23.4,23.4,0,0,0,2.4-11.04C2.4-4.2,5.08.28,9.24.28c2.64,0,5.32-1.88,6.92-4.96A26.15,26.15,0,0,0,19.08-16C19.08-22.56,16.44-26.4,11.88-26.4Zm-1.16,1.84c3.32,0,5.64,4.76,5.64,11.44A17.177,17.177,0,0,1,14.48-4.8c-1.04,1.76-2.28,2.64-3.84,2.64-3.4,0-5.92-4.6-5.92-10.72C4.72-19.28,7.44-24.56,10.72-24.56Zm26.76,8.8c3.24-2.76,4.36-4.48,4.36-6.68,0-2.48-1.72-4-4.52-4a7.957,7.957,0,0,0-5.36,2.36q-1.32,1.2-1.32,1.8a.643.643,0,0,0,.6.52,1.03,1.03,0,0,0,.64-.28,9.626,9.626,0,0,1,1.68-1.44,4.6,4.6,0,0,1,2.36-.68,2.752,2.752,0,0,1,2.92,2.84c0,1.76-.92,3.36-2.88,5.08a7.161,7.161,0,0,1-2.24,1.36c-.52.2-.72.36-.72.72a.454.454,0,0,0,.44.48c.08,0,.32-.04.64-.08a5.134,5.134,0,0,1,.88-.04,3.866,3.866,0,0,1,4.12,4.2c0,4.32-3.32,8.24-7.04,8.24a7.247,7.247,0,0,1-3.6-1.08,1.394,1.394,0,0,0-.68-.24.688.688,0,0,0-.64.64C27.12-.96,29.8.28,32.04.28,37.6.28,42.36-4.8,42.36-10.68a4.935,4.935,0,0,0-1.68-4A6.9,6.9,0,0,0,37.48-15.76Z" transform="translate(-2.4 26.44)" fill="#bc818b"/></svg>';
        }
      }
    }
  }


  window.addEventListener('load',()=>{
    homeHeader();
    jsMh();
    jsAcod();
    scrlAnime();
    featBlk();
  });
  window.addEventListener('shopify:section:load',()=>{
    jsMh();
    featBlk();
  });
  window.addEventListener('shopify:section:reorder',()=>{
    jsMh();
    featBlk();
  });

})();